/* import __COLOCATED_TEMPLATE__ from './header-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();